module.exports = __webpack_public_path__ + "img/Jatropha_curcas.cd9c025a.jpg";